import './context-picking-presence.css';

import { SelectIcon } from '@blocksuite/icons/lit';
import { lightThemeV2 } from '@streamlain/theme/v2';
import { render } from 'lit';

import {
  CONTEXT_PICKING_CURSOR_PROPERTY,
  CONTEXT_PICKING_SCREEN_ATTRIBUTE,
} from './context-picking-attributes';

/** Arrow tip of the 24px selector icon. */
const CURSOR_HOTSPOT = '4 3';
const cursors = new WeakMap<Document, string>();

/** The selector button's own icon, serialized once per document as a CSS cursor. */
function pickingCursor(document: Document): string {
  const cached = cursors.get(document);
  if (cached) return cached;
  const container = document.createElement('div');
  render(
    SelectIcon({
      width: '24',
      height: '24',
      style: `color:${lightThemeV2['button/primary']}`,
    }),
    container
  );
  const icon = container.firstElementChild;
  if (!icon) throw new Error('Selector icon did not render');
  const markup = new XMLSerializer().serializeToString(icon);
  const cursor = `url("data:image/svg+xml,${encodeURIComponent(markup)}") ${CURSOR_HOTSPOT}, crosshair`;
  cursors.set(document, cursor);
  return cursor;
}

/** Whole-screen picking presence: inward pulse plus the selector cursor over picking roots. */
export function showContextPickingScreen(document: Document): () => void {
  const root = document.documentElement;
  root.style.setProperty(
    CONTEXT_PICKING_CURSOR_PROPERTY,
    pickingCursor(document)
  );
  root.setAttribute(CONTEXT_PICKING_SCREEN_ATTRIBUTE, '');
  return () => {
    root.removeAttribute(CONTEXT_PICKING_SCREEN_ATTRIBUTE);
    root.style.removeProperty(CONTEXT_PICKING_CURSOR_PROPERTY);
  };
}
